import MovimientoManagementPage from '../pages/MovimientoManagementPage'

const routes = [
    { name: 'MovimientoManagementPage', path: '/movimiento-management', component: MovimientoManagementPage }
]

export default routes;
